<div class="login-container">
    <div class="image-holder">
        <!--<h1>Crewcus.</h1>-->
    </div>
    <div class="text-holder" (keyup.enter)="!(!email || password != confirm || !email && password != confirm || !password || isLoading)  ? register() : false">

        <h2>Register New Account</h2>
        <h3 style="margin-bottom:30px">Please fill out the form below</h3>
        <span *ngIf="errortext" style="color:red">{{errortext}}</span>
        <label>email address</label>
        <input #focusthis [(ngModel)]="email" type="email" placeholder="Enter email">
        <label>password</label>
        <input [(ngModel)]="password" type="password" placeholder="Enter password">
        <label>confirm password</label>
        <input [(ngModel)]="confirm" type="password" placeholder="Confirm password">

        <button (click)="register()" [disabled]="!email || password != confirm || !email && password != confirm || !password || isLoading ">
           <ng-container *ngIf="!isLoading">Register</ng-container>
           <img *ngIf="isLoading" class="spin" src="../../../assets/img/loading.svg" style="width:20px">
        </button>
        <div class="flex left-right">
            <a [routerLink]="['/auth/login']" routerLinkActive="router-link-active">Already have an account</a>

        </div>

    </div>
</div>

<div class="hero-bg"></div>